import { Box, Button, Typography, Container } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import emptyItemsList from "../../../../../../../public/images/emptyItemsList.png";
import { useHistory, useParams } from "react-router";
export const ItemListEmpty = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    modelZUID
  } = useParams<{
    modelZUID: string;
  }>();
  return <Container maxWidth="lg" disableGutters sx={{
    height: "100%"
  }} data-sentry-element="Container" data-sentry-component="ItemListEmpty" data-sentry-source-file="ItemListEmpty.tsx">
      <Box height="100%" display="flex" alignItems="center" justifyContent={"space-between"} gap={8} data-sentry-element="Box" data-sentry-source-file="ItemListEmpty.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="ItemListEmpty.tsx">
          <Typography variant="h4" fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="ItemListEmpty.tsx">
            {t("content.itemListEmptyTitle")}
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1} mb={2} data-sentry-element="Typography" data-sentry-source-file="ItemListEmpty.tsx">
            {t("content.itemListEmptyDescription")}
          </Typography>
          <Button variant="contained" color="primary" startIcon={<Add />} size="small" onClick={() => {
          history.push(`/content/${modelZUID}/new`);
        }} data-sentry-element="Button" data-sentry-source-file="ItemListEmpty.tsx">
            {t("common.create")}
          </Button>
        </Box>
        <Box component="img" src={emptyItemsList} data-sentry-element="Box" data-sentry-source-file="ItemListEmpty.tsx" />
      </Box>
    </Container>;
};